export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.topedox.com/topedox_dev/api/v1',
  //  apiBaseUrl: 'https://api.topedox.com/api/v1',
  socketUrl:'dev.topedox.com/topedox_dev/api/v1',
  vapidKey: "BPSzIiUyVSvrW1M7iqUCbT7wBqbClcLROsEpOcvdZziSRw2bZLVDf5W-XbcIc1VWB1GU7LtE8by7TC6uT0NCLk4"
};